function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#4FCEC8",
  cx: "10.5",
  cy: "10.5",
  r: "10.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.692 9.59a1 1 0 00-1.384 1.444l2.283 2.188a1 1 0 001.382.002l4.717-4.5a1 1 0 00-1.38-1.448l-4.026 3.84-1.592-1.525z",
  fill: "#FFF"
}))));